import PageLoading from 'components/common/loading/PageLoading'
import { AppRole, usePermissions } from 'pages/authenticated/PermissionsContext'
import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

type RoleGuardProps = {
  roles: AppRole[]
  children: ReactNode
}

const RoleGuard = ({ roles, children }: RoleGuardProps) => {
  const { loading, role } = usePermissions()
  if (loading) return <PageLoading />
  if (!role || !roles.includes(role)) return <Navigate to="/forbidden" replace />
  return <>{children}</>
}

export default RoleGuard

